import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const PayCalendarGridIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      strokeWidth={strokeWidth}
      viewBox="0 0 24 24"
    >
      <path
        d="M22 3.25H18.75V1.75C18.75 1.34 18.41 1 18 1C17.59 1 17.25 1.34 17.25 1.75V3.25H6.75V1.75C6.75 1.34 6.41 1 6 1C5.59 1 5.25 1.34 5.25 1.75V3.25H2C1.04 3.25 0.25 4.04 0.25 5V20C0.25 21.52 1.48 22.75 3 22.75H21C22.52 22.75 23.75 21.52 23.75 20V5C23.75 4.04 22.96 3.25 22 3.25ZM1.75 9.62H11.37V14.87H1.75V9.62ZM12.62 9.62H22.24V14.87H12.62V9.62ZM2 4.75H22C22.14 4.75 22.25 4.86 22.25 5V8.38H1.75V5C1.75 4.86 1.86 4.75 2 4.75ZM1.75 20V16.12H11.37V21.24H3C2.31 21.24 1.75 20.68 1.75 19.99V20ZM21 21.25H12.62V16.13H22.24V20.01C22.24 20.7 21.68 21.26 20.99 21.26L21 21.25Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

PayCalendarGridIcon.displayName = 'PayCalendarGridIcon';
